module.exports = __webpack_public_path__ + "static/img/recommend-list-3.7203848.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/main/recommend-list-3.png
// module id = djtr
// module chunks = 1